import { useOutlet } from "react-router-dom";

import { AppProviders } from "@/components/providers/app-providers";
import { StoreShell } from "@/components/layout/store-shell";

import "@/styles/globals.css";

/**
 * The React equivalent of `app/layout.tsx`.
 *
 * `<html>`/`<body>` come from `index.html` now; the provider stack and the
 * storefront chrome are unchanged from the Next.js version.
 */
export default function RootLayout() {
  // React Router renders the child route into this outlet.
  const children = useOutlet();

  return (
    <AppProviders>
      <StoreShell>{children}</StoreShell>
    </AppProviders>
  );
}